import { Helmet } from 'react-helmet-async'

import type { AppMetadata } from '@/lib/seo'

type SeoHeadProps = {
  metadata: AppMetadata
}

export function SeoHead({ metadata }: SeoHeadProps) {
  const { openGraph, twitter } = metadata

  return (
    <Helmet>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      {metadata.keywords.length > 0 ? (
        <meta name="keywords" content={metadata.keywords.join(', ')} />
      ) : null}
      <link rel="canonical" href={metadata.canonical} />
      {metadata.noIndex ? (
        <meta name="robots" content="noindex, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      <meta property="og:type" content={openGraph.type} />
      <meta property="og:url" content={openGraph.url} />
      <meta property="og:title" content={openGraph.title} />
      <meta property="og:description" content={openGraph.description} />
      <meta property="og:site_name" content={openGraph.siteName} />
      <meta property="og:locale" content={openGraph.locale} />
      <meta property="og:image" content={openGraph.image.url} />
      <meta property="og:image:width" content={String(openGraph.image.width)} />
      <meta property="og:image:height" content={String(openGraph.image.height)} />
      <meta property="og:image:alt" content={openGraph.image.alt} />
      {openGraph.publishedTime ? (
        <meta property="article:published_time" content={openGraph.publishedTime} />
      ) : null}
      {openGraph.modifiedTime ? (
        <meta property="article:modified_time" content={openGraph.modifiedTime} />
      ) : null}
      {(openGraph.authors ?? []).map((author) => (
        <meta key={author} property="article:author" content={author} />
      ))}
      {(openGraph.tags ?? []).map((tag) => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
      <meta name="twitter:card" content={twitter.card} />
      <meta name="twitter:title" content={twitter.title} />
      <meta name="twitter:description" content={twitter.description} />
      <meta name="twitter:image" content={twitter.image} />
    </Helmet>
  )
}
